import { useState } from 'react';
import { useGetStatsQuery } from '@platform/state/api';
import type { IRecordTypeDefinition } from '@platform/core/types';
import type { IKpiSource } from './IKpiSource';
import type { IOverviewKpi } from './IOverviewKpi';
import type { KpiKey } from './KpiKey';
import { kpiKeysOf, kpiOf, kpiParamsOf, staleSinceOf } from './overviewKpi';

/**
 * Показники огляду головного типу запису: статистика `by=status` без фільтра, з пресетами overdue/due7/unassigned і фільтром «без змін 14
 * днів» — межа рахується один раз на відкриття сторінки (як Date.now() прототипу при побудові огляду).
 */
export function useOverviewKpis(ws: string, rt: IRecordTypeDefinition): IOverviewKpi[] {
  const keys = kpiKeysOf(rt);
  const [since] = useState(() => staleSinceOf(Date.now()));
  const arg = (key: KpiKey) => ({ ws, rt: rt.key, by: 'status', params: kpiParamsOf(key, since) });
  const all = useGetStatsQuery(arg('total'));
  const overdue = useGetStatsQuery(arg('overdue'), { skip: !keys.includes('overdue') });
  const due7 = useGetStatsQuery(arg('due7'), { skip: !keys.includes('due7') });
  const unassigned = useGetStatsQuery(arg('unassigned'), { skip: !keys.includes('unassigned') });
  const stale = useGetStatsQuery(arg('stale'));
  const sources: Record<KpiKey, IKpiSource> = { total: all, open: all, overdue, due7, unassigned, stale };
  return keys.map((key) => kpiOf(key, sources[key], rt.statuses));
}
